import { Injectable } from '@angular/core';
import {LoadingService} from "../../../shared/loading-service/loading.service";
import {HttpEvent, HttpHandler, HttpRequest} from "@angular/common/http";
import {catchError, tap} from "rxjs/operators";
import {Observable, throwError} from "rxjs";
import {environment} from "../../../../environments/environment";
import {ErrorService} from "../../alert-and-error/error.service";
import {AlertService} from "../../alert-and-error/alert.service";

@Injectable({
  providedIn: 'root'
})
export class AlertAndErrorService {

  constructor(private errorService: ErrorService,
              private alertService: AlertService,
              private loadingService:LoadingService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!environment.openUrls.some(value => value == request.url)) {
      return next.handle(request).pipe(
          tap(evt => {
            this.alertService.handle(request, evt);
          }),
          catchError(err => {
            this.loadingService.setFormLoading(false);
            this.loadingService.setApiLoading(false);
            this.errorService.handle(request, err);
            if (err.status == 300) {
              return throwError(err);
            } else {
              return throwError(err.error|| err?.statusText);
            }
          }));
    }
    return next.handle(request);
  }
}
